/**
 * 숫자 콤마 포맷 (ko-KR) — 단일 출처 (TASK-149, 2026-09-20)
 *
 * 사용처:
 *  - 전역 메서드: 컴포넌트 템플릿/스크립트에서 `$formatNumber(value, digits)` (app.js 에서 Vue.prototype 등록, import 불필요)
 *  - 호환층: components/app/mixins/format-number.js (헤더·사이드바 기존 호출) 가 본 함수에 위임
 *  - 직접 import: 컴포넌트 외 스크립트에서 `import { formatNumber } from '../utils/format-number'`
 *
 * ※ v-comma-number 디렉티브 (app.js) 는 소수 자릿수를 자르지 않는 별도 동작이라 본 함수에 위임하지 않음 (회귀 방지).
 *
 * @param {number|string|null|undefined} value
 * @param {number|null} digits 소수 자릿수 고정 (null = 정수 그대로, 소수는 toLocaleString 기본 최대 3자리)
 * @return {string}
 */
export function formatNumber(value, digits = null) {
    if (value === null || value === undefined) {
        return '0';
    }
    if (digits === null) {
        return Number(value).toLocaleString('ko-KR');
    }
    return Number(value).toLocaleString('ko-KR', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    });
}

export default formatNumber;
